require('./impromptu');
import Trackers from '../tracker/tracker';
let form = require('../form/form');
import { YandexSmartCaptcha } from '../../modules/YandexSmartCaptcha/yandex-smart-captcha';
jQuery(function() {
    new YandexSmartCaptcha('detail_element_add_reviews_captcha').init();
    var addReviewFormHtml = $('.js-review-add_container').html();
    /**
     *  Отзывы
     * @type {{addReview: {html: *, submit: function(*, *, *): void}}}
     */
    var addReviewPrompt = {
        addReview: {
            html: addReviewFormHtml,

            submit: function(e, v, m) {
                e.preventDefault();
                let $this = $(this);
                var $params = $.extend({}, form.formValidateDefaults, {
                    rules: {
                        review_name: { required: true },
                        review_city: { required: true },
                        review_activity: { required: true },
                        review_rating: {},
                        question_comment: {}
                    },
                    messages: {
                        review_name: { required: 'Не указано имя' },
                        review_city: { required: 'Не указан город' },
                        review_activity: {
                            required: 'Не указан род деятельности'
                        }
                    },
                    submitHandler: function() {
                        $.ajax({
                            type: 'POST',
                            url: '/ajax/action/reviews/add/',
                            data: $('form.jqiform').serializeArray(),
                            success: function(result) {
                                if (result.code === 200) {
                                    let trackers = new Trackers();
                                    trackers.onPMfrmComment();
                                    $.prompt
                                        .getState('addReview')
                                        .find('.form')
                                        .html('<p>' + result.html + '</p>');
                                } else {
                                    let errorDiv = $('<div/>', {
                                        class: 'form__error-msg',
                                        text: result.data.error
                                    });
                                    $this.find('.form__head-label').after(errorDiv);
                                }
                            }
                        });
                        //т.к. изменилась высота блока, надо его подвинуть в видимую часть окна,
                        // чтобы не казалось, будто он совсем пропал с экрана
                        $.prompt.position();
                    }
                });
                var $form = m.closest('form');
                $form.validate($params);
            }
        }
    };

    /**
     * Вопрос ответ
     * @type {{addQuestion: {html: string, submit: function(*, *, *): void}}}
     */
    var addQuestionPrompt = {
        addQuestion: {
            html: '',
            submit: function(e, v, m) {
                e.preventDefault();
                let $this = $(this);
                var $params = $.extend({}, form.formValidateDefaults, {
                    rules: {
                        question_name: { required: true },
                        question_email: { required: true, email: true },
                        question_phone: { required: true, phoneMask: true },
                        question_city: { required: true },
                        question_activity: { required: true }
                    },
                    messages: {
                        question_name: { required: 'Не указано имя' },
                        question_city: { required: 'Не указан город' },
                        question_activity: {
                            required: 'Не указан род деятельности'
                        },
                        question_email: {
                            required: $.validator.messages.EMAIL.required,
                            email: $.validator.messages.EMAIL.email
                        },
                        question_phone: {
                            required: $.validator.messages.PHONE.required,
                            phoneMask: $.validator.messages.PHONE.phoneMask
                        }
                    },
                    submitHandler: function() {
                        $.ajax({
                            type: 'POST',
                            url: '/ajax/action/questions/add/',
                            data: $('form.jqiform').serializeArray(),
                            success: function(result) {
                                if (result.code === 200) {
                                    let trackers = new Trackers();
                                    trackers.onPMfrmAskQuestion();
                                    $.prompt
                                        .getState('addQuestion')
                                        .find('.form')
                                        .html('<p>' + result.html + '</p>');
                                } else {
                                    let errorDiv = $('<div/>', {
                                        class: 'error form__error-msg',
                                        text: result.data.error
                                    });
                                    $this.find('.form__head-label').after(errorDiv);
                                }
                            }
                        });
                        //т.к. изменилась высота блока, надо его подвинуть в видимую часть окна,
                        // чтобы не казалось, будто он совсем пропал с экрана
                        $.prompt.position();
                        //$.prompt.close();
                    }
                });
                var $form = m.closest('form');
                $form.validate($params);
            }
        }
    };

    $(document).on('click', '.js-jqi-add-review', function(e) {
        e.preventDefault();
        let trackers = new Trackers();
        trackers.onPMbtnComment();
        $.prompt(addReviewPrompt);
    });

    $(document).on('click', '.js-jqi-add-review-question', function(e) {
        var elementID = $(this).data('element_id');
        e.preventDefault();
        $.ajax({
            url: '/ajax/action/questions/showPopupForm/?element_id=' + elementID,
            success: function(result) {
                addQuestionPrompt.addQuestion.html = result.html;
                $.prompt(addQuestionPrompt);
                let trackers = new Trackers();
                trackers.onPMbtnAskQuestion();
                new YandexSmartCaptcha('detail_element_add_question_captcha').init();
            }
        });
    });
});



// WEBPACK FOOTER //
// ./blocks/impromptu/impromptu-review.js